<script lang="ts" generics="T extends any">
  import PaginatedCollectionLoader from './PaginatedCollectionLoader.svelte'

  export let items: T[] | undefined
  export let url: string
  export let per = 12
  export let search: string | undefined = undefined
  export let order = ''

  let disabled = false

  async function onClick(loadNext: () => Promise<any>) {
    disabled = true
    try {
      await loadNext()
    } finally {
      disabled = false
    }
  }
</script>

<PaginatedCollectionLoader bind:items {url} {per} {search} {order} let:loadNext>
  <div class="load-more" onclick={() => onClick(loadNext)} role="button">
    <a class="icon-p-load-more" class:disabled={disabled}/>
  </div>
</PaginatedCollectionLoader>

<style>
  .icon-p-load-more {
    cursor: pointer;
  }

  .icon-p-load-more.disabled {
    cursor: default;
    pointer-events: none;
    color: #b3b3b3;
  }
</style>